/**
 * 知识库相关API服务
 * 包含知识库的增删查改、状态切换等功能
 */

import { fetcher } from '../base/fetcher'
import type {
  KnowledgeBase,
  GetKnowledgeListRequest,
  KnowledgeListResponse,
  SaveOrUpdateKnowledgeRequest,
  DeleteKnowledgeRequest,
  ToggleKnowledgeStateRequest,
} from '../types/knowledge.types'

/**
 * 知识库相关API路径常量
 */
export const KNOWLEDGE_API_PATHS = {
  /** 获取知识库列表 */
  LIST: '/knowledgeBase/list',
  /** 新增/编辑知识库 */
  SAVE_OR_UPDATE: '/knowledgeBase/saveOrUpdate',
  /** 删除知识库 */
  DELETE: '/knowledgeBase/delById',
  /** 切换知识库状态 */
  TOGGLE_STATE: '/knowledgeBase/toggleState',
} as const

/**
 * 知识库服务对象
 * 提供所有知识库相关的API调用方法
 */
export const knowledgeService = {
  /**
   * 获取知识库列表
   * @param params 查询参数（创建人、关键词、分页等）
   * @returns 知识库列表和分页信息
   */
  getKnowledgeList: (params: GetKnowledgeListRequest) => {
    // 将参数转换为字符串类型以符合fetcher要求
    const stringParams: Record<string, string> = {}
    if (params.workspaceId) stringParams.workspaceId = params.workspaceId
    if (params.search) stringParams.search = params.search

    return fetcher.get<KnowledgeListResponse>(KNOWLEDGE_API_PATHS.LIST, {
      params: stringParams,
    })
  },

  /**
   * 新增或编辑知识库
   * @param data 知识库信息（新增时不传id，编辑时必传id）
   * @returns 操作结果
   */
  saveOrUpdateKnowledge: (data: SaveOrUpdateKnowledgeRequest) =>
    fetcher.post<KnowledgeBase>(KNOWLEDGE_API_PATHS.SAVE_OR_UPDATE, data),

  /**
   * 删除知识库
   * @param data 删除参数（知识库ID）
   * @returns 删除结果
   */
  deleteKnowledge: (data: DeleteKnowledgeRequest) =>
    fetcher.post<boolean>(KNOWLEDGE_API_PATHS.DELETE, data),

  /**
   * 切换知识库启用状态
   * @param data 状态切换参数（知识库ID、是否启用）
   * @returns 切换结果
   */
  toggleKnowledgeState: (data: ToggleKnowledgeStateRequest) =>
    fetcher.post<boolean>(KNOWLEDGE_API_PATHS.TOGGLE_STATE, data),
}
